
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class WhatsAppMessagesGrid extends Serenity.EntityGrid<WhatsAppMessagesRow, any> {
        protected getColumnsKey() { return WhatsAppMessagesColumns.columnsKey; }
        protected getDialogType() { return WhatsAppMessagesDialog; }
        protected getIdProperty() { return WhatsAppMessagesRow.idProperty; }
        protected getInsertPermission() { return WhatsAppMessagesRow.insertPermission; }
        protected getLocalTextPrefix() { return WhatsAppMessagesRow.localTextPrefix; }
        protected getService() { return WhatsAppMessagesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}